import React from "react";
import { PolicyStudioSidebar } from "./PolicyStudioSidebar";
import { PolicyStudioViewer } from "./PolicyStudioViewer";
import { Toaster } from "react-hot-toast";
import DrawerPolicyConflicts from "./DrawerPolicyConflicts";
import DrawerPolicyCompliance from "./DrawerPolicyCompliance";
import { usePolicyStudio } from "../../hooks/usePolicyStudio";
import "./PolicyStudio.css";
import config from "environment";

const PolicyStudio: React.FC = () => {
  const { state, actions } = usePolicyStudio();

  if (!config.showPolicyStudio) {
    return null;
  }

  return (
    <div className="policy-studio light-mode">
      <div className="policy-studio__sidebar">
        <PolicyStudioSidebar
          policyProjects={state.policyProjects}
          policy={state.selectedPolicy}
          isLoading={state.isLoading}
          onSelectPolicy={actions.setSelectedPolicy}
          handlePolicyCreation={actions.createPolicy}
          handleAdjustmentUpdate={actions.updateFromAdjustment}
          handlePromptUpdate={actions.updateFromPrompt}
          handlePolicyTitleUpdate={actions.updateTitle}
          handleUploadFile={actions.uploadFile}
          handleCreateFromLinkRecord={actions.createFromLinkRecord}
          handleDelete={actions.handleDelete}
          linkRecords={state.linkRecords}
          isPublic={false}
          isCreateModalOpen={state.isCreateModalOpen}
          handleAddNewClick={actions.handleAddNewClick}
          handleCloseCreateModal={actions.handleCloseCreateModal}
          handleCreateFromFileClick={actions.handleCreateFromFileClick}
          isCreateFromFileModalOpen={state.isCreateFromFileModalOpen}
          handleCloseCreateFromFileModal={
            actions.handleCloseCreateFromFileModal
          }
          isStreaming={state.isStreaming}
        />
      </div>
      <div className="policy-studio__viewer">
        <PolicyStudioViewer
          policy={state.selectedPolicy}
          isLoading={state.isLoading}
          handleAddNewClick={actions.handleAddNewClick}
          handleAddAsResource={actions.addAsResource}
          openConflictsDrawer={actions.openConflictsDrawer}
          openComplianceDrawer={actions.openComplianceDrawer}
          exportContentToPdf={actions.exportToPdf}
          updatePolicyContent={actions.updateContent}
          isPublic={false}
        />
      </div>
      <DrawerPolicyConflicts
        isOpen={state.isConflictsDrawerOpen}
        onClose={actions.closeConflictsDrawer}
        linkRecords={state.linkRecords}
        handleCheckConflicts={actions.findConflicts}
        conflictsCheckResults={state.selectedPolicy?.conflicts}
        isLoading={state.drawerIsLoading}
        exportToPdf={actions.exportToPdf}
        isDirty={state.selectedPolicy?.conflictsDirty || false}
        isPublic={false}
      />

      <DrawerPolicyCompliance
        isOpen={state.isComplianceDrawerOpen}
        onClose={actions.closeComplianceDrawer}
        handleCheckCompliance={actions.checkCompliance}
        complianceCheckResults={state.selectedPolicy?.compliance}
        isLoading={state.drawerIsLoading}
        exportToPdf={actions.exportToPdf}
        isDirty={state.selectedPolicy?.complianceDirty || false}
        isPublic={false}
      />
      <Toaster />
    </div>
  );
};

export default PolicyStudio;
